<div
    [ngClass]="[
        direction() === 'horizontal' ? 'flex-col' : 'flex-row',
        wrap() ? '!flex-row items-start !gap-3' : '',
    ]"
    class="flex gap-2"
>
    @if (label()) {
        <app-label [ngClass]="wrap() ? 'mt-2' : ''" [required]="required()!">{{
            label()
        }}</app-label>
    }
    @if (hint()) {
        <app-hint>{{ hint() }}</app-hint>
    }
    <div
        [ngClass]="
            direction() === 'horizontal'
                ? 'flex flex-row gap-3 items-center'
                : 'flex flex-col gap-2'
        "
        class="flex flex-wrap gap-3"
    >
        @for (option of options(); track $index) {
            @let check = value()?.includes(option.value)!;

            <button
                type="button"
                (click)="handleValueChange(!check, option.value)"
                class="p-3 rounded-xl hover:bg-gray-100 transition-colors border"
                [ngClass]="{ 'bg-primary-50 hover:bg-primary-50': check }"
            >
                <app-checkbox
                    [size]="size() || 'md'"
                    [value]="check"
                    [modelValue]="option.value"
                    [label]="option.label"
                    [description]="option.description || ''"
                />
            </button>
        }
    </div>
</div>
